import { CompSelectionProperty } from '../../types.ts';
import {
  SIMILARITY_FEATURES,
  SimilarityFeatureKey,
  similarityFeatureDefs,
  similarityFeatureMapping,
} from './features.ts';

export function calcSimilarity(
  subject: CompSelectionProperty,
  comp: CompSelectionProperty,
): number {
  function distance(key: SimilarityFeatureKey): number {
    const f = similarityFeatureMapping[key];
    let d = 1 - Math.abs((f(subject) ?? 0) - (f(comp) ?? 0)) / similarityFeatureDefs[key].maxRange;
    d = Math.max(0, Math.min(1, d)); // Clamp the value of d between 0 and 1
    // if either subject or comp is missing the value, we treat this feature as having a distance of 0
    return Number.isFinite(d) ? d : 0;
  }

  const totalDistance = SIMILARITY_FEATURES.map(
    (k) => similarityFeatureDefs[k].weight * distance(k),
  ).reduce((a, b) => a + b, 0);

  return totalDistance;
}
